import {
  processFileChange,
  processFileCreate,
  processFileDelete,
  processFolderCreate,
} from '../services/vibeCodingService';
import {
  VIBE_CODING_FILE_CHANGE_BEGIN,
  VIBE_CODING_FILE_CHANGE_SUCCESS,
  VIBE_CODING_FILE_CHANGE_FAILURE,
} from './constants';

const begin = () => ({ type: VIBE_CODING_FILE_CHANGE_BEGIN });
const fail = (error) => ({
  type: VIBE_CODING_FILE_CHANGE_FAILURE,
  data: { error },
});
const ok = (data) => ({
  type: VIBE_CODING_FILE_CHANGE_SUCCESS,
  data,
});

export const createWorkspaceFile =
  (args = {}) =>
  async (dispatch) => {
    dispatch(begin());
    try {
      //API Call
      const data = await processFileCreate(args);
      dispatch(ok(data));
      return data;
    } catch (error) {
      dispatch(fail(error));
      throw error;
    }
  };

export const createWorkspaceFolder =
  (args = {}) =>
  async (dispatch) => {
    dispatch(begin());
    try {
      const data = await processFolderCreate(args);
      dispatch(ok(data));
      return data;
    } catch (error) {
      dispatch(fail(error));
      throw error;
    }
  };

export const renameWorkspaceFile =
  (args = {}) =>
  async (dispatch) => {
    dispatch(begin());
    try {
      const data = await processFileChange(args);
      dispatch(ok(data));
      return data;
    } catch (error) {
      dispatch(fail(error));
      throw error;
    }
  };

export const deleteWorkspaceFile =
  (args = {}) =>
  async (dispatch) => {
    dispatch(begin());
    try {
      const data = await processFileDelete(args);
      dispatch(ok(data));
      if (args.projectId) {
        await dispatch(loadWorkspaceFiles({ projectId: args.projectId, version: args.version }));
      }
      return data;
    } catch (error) {
      dispatch(fail(error));
      throw error;
    }
  };

export function reducer(state, action) {
  switch (action.type) {
    case VIBE_CODING_FILE_CHANGE_BEGIN:
      return {
        ...state,
        loadingFileChange: true,
        fileChangeError: '',
      };
    case VIBE_CODING_FILE_CHANGE_SUCCESS:
      return {
        ...state,
        loadingFileChange: false,
        fileChangeError: '',
      };
    case VIBE_CODING_FILE_CHANGE_FAILURE:
      return {
        ...state,
        loadingFileChange: false,
        fileChangeError:
          (action.data &&
            action.data.error &&
            (action.data.error.message || String(action.data.error))) ||
          'Request failed',
      };
    default:
      return state;
  }
}
